 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		66: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		66: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~be20fca5","3":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~cf939e27","4":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~reverse-image-search~stylequiz","5":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","7":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","8":"BuyItAgainTypeaheadPreWrapper","9":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","10":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","11":"ratings-and-reviews-mobile","12":"buybox~promotion-products-lazy","13":"compare~orange-lens","14":"media-gallery-overlay~media-gallery-overlay-mobile","15":"orange-lens~reverse-image-search","16":"ratings-and-reviews-desktop","18":"StoreLayout","19":"add-to-list-drawer","20":"aisle-bay","21":"augmented-reality","22":"bath-renovation","23":"breadcrumbs","24":"browse-and-search","25":"browse-and-search-mobile","26":"buybox","27":"calculator-pipcalculator","28":"collections","29":"collections-mobile","30":"compare","31":"consumer-card-messaging","32":"customer-image-overlay","33":"drawer","34":"emt-generated-content","35":"emt-links","36":"fulfillment","37":"global-custom-configurator","39":"home","40":"magic-apron","41":"measurement-guide","42":"measurement-guide-overlay-content","43":"media-gallery-filmstrip-mobile","44":"media-gallery-overlay","45":"media-gallery-overlay-mobile","46":"message-types","47":"orange-lens","48":"order-sample","49":"order-sample-drawer","50":"overlay","51":"paint-reorder","52":"paint-reorder-mobile","53":"pep","54":"pep-mobile","55":"product","56":"product-mobile","57":"product-overview","58":"promotion-products-lazy","59":"question","60":"questions-and-answers","61":"quick-view","62":"ratings-and-reviews","63":"results","64":"returns-messaging","65":"reverse-image-search","67":"share-to-email-overlay","68":"share-to-pinterest-overlay","69":"size-guide-overlay","70":"specifications","71":"stylequiz","72":"vendor-collection-products","73":"vendor-collections","74":"vendor-collections-mobile","76":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"bf4217d5af955ef89fd3","1":"c9bd4f4a79f210479086","2":"64d0dfd06cce591f6dc1","3":"aca8a6905634f3c9fad3","4":"117a6c44a1430a25c978","5":"606e24a50e3678f5f46d","6":"15b483c2e8f862b380e6","7":"d7f60db8da12f3476e17","8":"70becd6250011bb10c1d","9":"110424daca683a536526","10":"7c8940d6e3700ec21a61","11":"bda0d9b4037df201c85d","12":"0385931d8bb1e4ff1d6b","13":"f772ea05b4a53334785a","14":"70324fc6383aee087ce3","15":"fdbf9ad496bbfb869748","16":"6317bceae8c40253e4bb","17":"576316578b3f2ffae934","18":"d57ca7d7f279fb4981bc","19":"73e9da04fbb788031030","20":"659adfea0b8222413bfb","21":"dc6c326c88d8be95c95e","22":"dff4eed01d3feb887537","23":"8fd1fae147cf2f83bdfc","24":"d386e05351c0037c6427","25":"4e8001f93707a16dad44","26":"393f3c8b8d9402fd0374","27":"e7db9d74f8e01eea69d4","28":"8d0debe8472dd42c0277","29":"df9398242cf2ac942047","30":"e5274b45106f781001bb","31":"a0f1b8fb68762b1e9314","32":"c9ff75fa8d9ec409f7f9","33":"e619e2de880be912bf82","34":"390c0e4d0729fdf60965","35":"1c5afec7442f269e6efb","36":"b88e14697a634a253c66","37":"544381f9771377fb5f7a","39":"617ca9db71cde74a0f53","40":"7f5ffda18ac2d79e11ce","41":"181e4f35d5bef2c420e6","42":"89c1aa7e458a0b7c8534","43":"0551f33093fc5c675c15","44":"a08ca4a06865e03856d9","45":"d18c37a6ad7434d0e739","46":"516058d64621c1caeb03","47":"dd3501109efe3c540653","48":"5a9e819de66c280a2b64","49":"4695a210caac08d7c30e","50":"f14baa93682ff6cceb3d","51":"0fbc93e77fb9bb1cde23","52":"b217a38370b34f1fb08d","53":"ffbce1ff28c1b9ce6074","54":"f1657a5c203504494d50","55":"c1e2f08cdaafb22fd509","56":"ceccdc43384954379f86","57":"0e01f1ae6182bf58b39d","58":"6c2f0d8a6d9dddd457bb","59":"f90bca21f336420ca8fa","60":"8f31df59ebc6eb6f4891","61":"867960918470afa0fe82","62":"1eaaeb31d5581848d2da","63":"4053266a8b09e36bff73","64":"64947c0f35692bb64f06","65":"b773a367ace9ee2f69ff","67":"c782c0c674de2ca4b004","68":"8b97f53008cbc03b80e9","69":"d1a09d0cabda68222807","70":"1059ed6c61e7281b7d84","71":"7a9eaead3fca7dc95129","72":"baea0818cab36e780b83","73":"764f163935433a68515f","74":"a76dfc5144278f140a5c","76":"d126bfc3a192a612e650","77":"8706804077b13f44577b","78":"5697bac16a299a172740","79":"444b4bf79d8f3c2ae9ac","80":"41cc69708c0dec3b00b1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"7":1,"9":1,"10":1,"11":1,"12":1,"14":1,"20":1,"22":1,"24":1,"25":1,"26":1,"28":1,"29":1,"30":1,"31":1,"33":1,"34":1,"36":1,"37":1,"40":1,"43":1,"44":1,"45":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"60":1,"61":1,"62":1,"63":1,"69":1,"71":1,"72":1,"73":1,"74":1,"76":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~be20fca5","3":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~cf939e27","4":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~reverse-image-search~stylequiz","5":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","7":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","8":"BuyItAgainTypeaheadPreWrapper","9":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","10":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","11":"ratings-and-reviews-mobile","12":"buybox~promotion-products-lazy","13":"compare~orange-lens","14":"media-gallery-overlay~media-gallery-overlay-mobile","15":"orange-lens~reverse-image-search","16":"ratings-and-reviews-desktop","18":"StoreLayout","19":"add-to-list-drawer","20":"aisle-bay","21":"augmented-reality","22":"bath-renovation","23":"breadcrumbs","24":"browse-and-search","25":"browse-and-search-mobile","26":"buybox","27":"calculator-pipcalculator","28":"collections","29":"collections-mobile","30":"compare","31":"consumer-card-messaging","32":"customer-image-overlay","33":"drawer","34":"emt-generated-content","35":"emt-links","36":"fulfillment","37":"global-custom-configurator","39":"home","40":"magic-apron","41":"measurement-guide","42":"measurement-guide-overlay-content","43":"media-gallery-filmstrip-mobile","44":"media-gallery-overlay","45":"media-gallery-overlay-mobile","46":"message-types","47":"orange-lens","48":"order-sample","49":"order-sample-drawer","50":"overlay","51":"paint-reorder","52":"paint-reorder-mobile","53":"pep","54":"pep-mobile","55":"product","56":"product-mobile","57":"product-overview","58":"promotion-products-lazy","59":"question","60":"questions-and-answers","61":"quick-view","62":"ratings-and-reviews","63":"results","64":"returns-messaging","65":"reverse-image-search","67":"share-to-email-overlay","68":"share-to-pinterest-overlay","69":"size-guide-overlay","70":"specifications","71":"stylequiz","72":"vendor-collection-products","73":"vendor-collections","74":"vendor-collections-mobile","76":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"d72ddc6d6ad5d75cad74","1":"ae101fda583e7f2b6c7f","2":"2033e2b2c7759f5f4cb0","3":"993d4999fdb3e390bd0c","4":"89d9163eeb30e835d559","5":"50d430c72ccc3cf96a34","6":"31d6cfe0d16ae931b73c","7":"f5a53b21f1e96abc5167","8":"31d6cfe0d16ae931b73c","9":"0ef658ad0521bc70e648","10":"d8b21b7e70d92d0b70e1","11":"6f5b9f83e7f38438fd0d","12":"7b5857f17ea967e685b8","13":"31d6cfe0d16ae931b73c","14":"9cb446a01d4d917f1dbc","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"853e5ca78c8a7aa34a62","21":"31d6cfe0d16ae931b73c","22":"5033e42da1bac3702418","23":"31d6cfe0d16ae931b73c","24":"04325c0196b8f52260d1","25":"c304a302ee7e7355bf1d","26":"38d2233ec62d32df2250","27":"31d6cfe0d16ae931b73c","28":"2223c8eb283b24bd1aae","29":"7aeabf3c06271915b9e9","30":"21826578c6df476105cb","31":"eb405aa31c203a69394d","32":"31d6cfe0d16ae931b73c","33":"fc73174b407ad863c497","34":"b49004ddac99adec2224","35":"31d6cfe0d16ae931b73c","36":"ddf04856a4fe5106f34b","37":"1a5562a08d12f7682989","39":"31d6cfe0d16ae931b73c","40":"ceebf150d8a696023a14","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"beffd19446c8e7dc1ee9","44":"7013f93350fef54e51c5","45":"ef46722a6934367ca9d2","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"3c1eb056048e8cf26c9a","51":"935e1e1fb6425f13083d","52":"bd2a14ee0801f18a9126","53":"d70b0b73ee00761698cd","54":"aea08bdaf10c75486793","55":"e2a1b62b8e1f2aa88b24","56":"592245600ffcc85065d9","57":"be155bb5d11dacdc4bb8","58":"defbf98c233545a10bef","59":"31d6cfe0d16ae931b73c","60":"d70c859b20e57c1599c5","61":"b08202abad6f04bf774d","62":"9d02d79dc9b8f52f7762","63":"7612ae7fca12602593b9","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"61cbd6424db4af076f0c","70":"31d6cfe0d16ae931b73c","71":"9e476a2a33be170c242f","72":"e518e335254638969e62","73":"5ccd412c357c08d11907","74":"3913df3b5f8f4b03041e","76":"91b32e80237abea48b86","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
